module.exports = __webpack_public_path__ + "static/media/nikhil_mawar.6c30be79.jpg";